import { render } from "./acctrans-review.vue?vue&type=template&id=ad90f374&scoped=true"
import script from "./acctrans-review.vue?vue&type=script&lang=js"
export * from "./acctrans-review.vue?vue&type=script&lang=js"

import "./acctrans-review.vue?vue&type=style&index=0&id=ad90f374&lang=less&scoped=true"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad90f374"]])

export default __exports__